import { IAction } from "@webiz/redux-common";
import {
  RESET_HEADER,
  SET_HEADER,
} from "./MainTypes";

export interface ISMain{
  main: {
    header: {
      title: { icon: string, label: string, path: string }
    }
  };
}

const initialState = {
    title: { icon: "", label: "", path: "" },
};

export function MainReducer(state = initialState, action: IAction) {
  switch (action.type) {
    case SET_HEADER:
      return { ...state, ...action.payload };
    case RESET_HEADER:
      return { ...initialState };
    default:
      return state;
  }
}
